import React from "react";
import Achievement from "../../components/Achievement";
import { FaArrowTurnDown } from "react-icons/fa6";
import { Link } from "react-scroll";
import { crane } from "../../assets";
import "./Hero.css";

const Hero = () => {
  return (
    <section id="hero" className="blur__effect">
      <div className="overlay__div">
        <div className="container">
          <div className="column left">
            <div className="hero__content">
              <h1 className="heading">
                Ashfaq Builders – Turning Your Dream Projects into Timeless
                Architectural Landmarks
              </h1>
              <p className="description">
                Since 1985, Ashfaq Builders has been committed to delivering exceptional construction services with a focus on innovation, sustainability, and client satisfaction. Backed by over 40 years of industry experience, we transform ideas into enduring residential, commercial, and industrial spaces through superior craftsmanship, precision, and unwavering dedication to quality.
              </p>
            </div>
            <Achievement />
            <div className="flex__center buttons__wrapper">
              <Link to="portfolio" smooth={true} className="btn">
                Projects
                <FaArrowTurnDown />
              </Link>
              <Link
                to="contact"
                smooth={true}
                className="flex__center btn primary"
              >
                Contact Us <FaArrowTurnDown />
              </Link>
            </div>
          </div>
          <div className="column hero__image-container object__contain">
            <img src={crane} alt="" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
